/* eslint-disable import/no-anonymous-default-export */
export default {
  gs3t_first_title: '青萍溫濕度計 T',
  goose3t: '青萍溫濕度計 T',
  gs3t_first_desc_2: '支援 Matter',
  gs3t_banner_title: '青萍溫濕度計 T',
  gs3t_banner_desc: '冷暖乾濕 一覽分明',
  gs3t_matter_title: '支援 Matter{sup}',
  gs3t_matter_desc: '可接入 Apple Home、Google Home、Amazon Alexa、{br}Samsung SmartThings 等支援 Matter 的智慧家居平台。',
  gs3t_matter_desc1: '透過 Siri 語音查詢溫濕度，隨時了解室內環境。',
  gs3t_matter_desc2: '透過 Alexa 建立智能聯動，如溫度升高時自動開啟空調{sup}。',
  gs3t_ten_list1: '需配備 Matter 中樞設備和 Thread 邊界路由器(或集成了 Thread 的 Matter 中樞設備，例如新款 HomePod 或 Apple TV、Google Nest Hub、Amazon Echo 等)。',
  gs3t_ten_list2: '需在 Alexa app 中設定聯動，並搭配兼容的智能空調。',
  gs3t_ten_list3: '實際續航時間可能依環境和電池的差異而有所不同。',
  gs3t_name: '青萍溫濕度計 T',
  gs3t_model: 'CGG3T',
  gs3t_ble: 'Thread、藍牙',
  gs3t_param_platform: '可接入 Apple Home、Google Home、Amazon Alexa、Samsung SmartThings 等支援 Matter 的智慧家居平台。',
  gs3t_support_matter: '支援 Matter',
}
